import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const Dashboard = () => {
    const auth = useContext(AuthContext);



    if (!auth) {
        throw new Error('AuthContext must be used within an AuthProvider');
    }

    const { user, logout } = auth;

    return <div className="row">

        {/* [ Row 1 ] start */}
        <div className="col-md-12 col-xxl-4">
            <div className="card statistics-card-1">
                <div className="card-body">
                    <img
                        src="../assets/images/widget/img-status-2.svg"
                        alt="img"
                        className="img-fluid img-bg"
                    />
                    <div className="d-flex align-items-center">
                        <div className="avtar bg-brand-color-1 text-white me-3">
                            <i className="ph-duotone ph-currency-dollar f-26" />
                        </div>
                        <div>
                            <p className="text-muted mb-0">Referrals</p>
                            <div className="d-flex align-items-end">
                                <h2 className="mb-0 f-w-500">$134.6K</h2>
                                <span className="badge bg-light-success ms-2">
                                    <i className="ti ti-chevrons-up" /> 55%
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-md-6 col-xxl-4">
            <div className="card statistics-card-1">
                <div className="card-body">
                    <img
                        src="../assets/images/widget/img-status-1.svg"
                        alt="img"
                        className="img-fluid img-bg"
                    />
                    <div className="d-flex align-items-center">
                        <div className="avtar bg-brand-color-2 text-white me-3">
                            <i className="ph-duotone ph-scales f-26" />
                        </div>
                        <div>
                            <p className="text-muted mb-0">Conversion Rate</p>
                            <div className="d-flex align-items-end">
                                <h2 className="mb-0 f-w-500">
                                    8.57<small className="text-muted">%</small>
                                </h2>
                                <span className="badge bg-light-danger ms-2">
                                    <i className="ti ti-chevrons-down" /> 3.6%
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-md-6 col-xxl-4">
            <div className="card statistics-card-1">
                <div className="card-body">
                    <img
                        src="../assets/images/widget/img-status-3.svg"
                        alt="img"
                        className="img-fluid img-bg"
                    />
                    <div className="d-flex align-items-center">
                        <div className="avtar bg-brand-color-3 text-white me-3">
                            <i className="ph-duotone ph-users-four f-26" />
                        </div>
                        <div>
                            <p className="text-muted mb-0">Visits</p>
                            <div className="d-flex align-items-end">
                                <h2 className="mb-0 f-w-500">278</h2>
                                <span className="badge bg-light-success ms-2">
                                    <i className="ti ti-chevrons-up" /> 7%
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* [ Row 1 ] end */}
        {/* [ Row 2 ] start */}
        <div className="col-md-6">
            <div className="card table-card">
                <div className="card-header">
                    <h5>Affiliates</h5>
                </div>
                <div className="card-body py-3 px-0">
                    <div className="table-responsive affiliate-table">
                        <table className="table table-hover table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-2.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">John Doe</h6>
                                        </div>
                                    </td>
                                    <td>Dashboard</td>
                                    <td className="text-end f-w-600">$38</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        5.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-1.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Keefs</h6>
                                        </div>
                                    </td>
                                    <td>New Website</td>
                                    <td className="text-end f-w-600">$928</td>
                                    <td>
                                        <i className="ti ti-arrow-down text-danger f-18 align-text-bottom" />{" "}
                                        51.2%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-3.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Lazaro</h6>
                                        </div>
                                    </td>
                                    <td>Dashboard</td>
                                    <td className="text-end f-w-600">$674</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        17.1%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-4.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Adeline</h6>
                                        </div>
                                    </td>
                                    <td>New Website</td>
                                    <td className="text-end f-w-600">$1,438</td>
                                    <td>
                                        <i className="ti ti-arrow-down text-danger f-18 align-text-bottom" />{" "}
                                        15.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-5.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">John Doe</h6>
                                        </div>
                                    </td>
                                    <td>Invoice</td>
                                    <td className="text-end f-w-600">$90</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        9.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-6.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Keefs</h6>
                                        </div>
                                    </td>
                                    <td>Dashboard</td>
                                    <td className="text-end f-w-600">$123</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        5.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-7.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Lazaro</h6>
                                        </div>
                                    </td>
                                    <td>Landing page</td>
                                    <td className="text-end f-w-600">$928</td>
                                    <td>
                                        <i className="ti ti-arrow-down text-danger f-18 align-text-bottom" />{" "}
                                        51.2%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div className="col-md-6">
            <div className="card table-card">
                <div className="card-header">
                    <h5>Top Visitors</h5>
                </div>
                <div className="card-body py-3 px-0">
                    <div className="table-responsive">
                        <table className="table table-hover table-borderless mb-0">
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-4.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Adeline</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$1,438</td>
                                    <td>
                                        <i className="ti ti-arrow-down text-danger f-18 align-text-bottom" />{" "}
                                        15.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-5.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">John Doe</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$90</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        9.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-6.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Keefs</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$123</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        5.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-7.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Lazaro</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$928</td>
                                    <td>
                                        <i className="ti ti-arrow-down text-danger f-18 align-text-bottom" />{" "}
                                        51.2%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-2.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">John Doe</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$38</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        5.8%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-1.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Keefs</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$928</td>
                                    <td>
                                        <i className="ti ti-arrow-down text-danger f-18 align-text-bottom" />{" "}
                                        51.2%
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img
                                                src="../assets/images/user/avatar-3.jpg"
                                                alt=""
                                                className="img-fluid wid-30 rounded-1"
                                            />
                                            <h6 className="mb-0 ms-2">Lazaro</h6>
                                        </div>
                                    </td>
                                    <td className="text-end f-w-600">$674</td>
                                    <td>
                                        <i className="ti ti-arrow-up text-success f-18 align-text-bottom" />{" "}
                                        17.1%
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        {/* [ Row 2 ] end */}
    </div>
}

export default Dashboard